import type { SxProps, Theme } from '@mui/material/styles';
import SvgIcon from '@mui/material/SvgIcon';

type Props = {
	sx?: SxProps<Theme>;
};

export const OpenDataCommercialMobileLogo = ({ sx }: Props) => {
	return (
		<SvgIcon
			width='37'
			height='36'
			viewBox='0 0 37 36'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			sx={sx}
		>
			<svg
				width='24'
				height='24'
				viewBox='0 0 24 24'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
			>
				<path
					d='M0 0H4.04007L11.7278 15.6659L19.3575 0H23.3249L11.6842 23.9632L0 0Z'
					fill='white'
				/>
				<path
					d='M6.40918 0.0444336L11.67 10.6775L16.9163 0.0444336H6.40918Z'
					fill='white'
				/>
			</svg>
		</SvgIcon>
	);
};
